import PropTypes from 'prop-types';

export const ImageProps = PropTypes.shape({
  EntityMediaID: PropTypes.string,
  MediaType: PropTypes.string,
  EntityID: PropTypes.string,
  EntityType: PropTypes.string,
  Title: PropTypes.string,
  Subtitle: PropTypes.string,
  Description: PropTypes.string,
  EmbedCode: PropTypes.string,
  Height: PropTypes.number,
  Width: PropTypes.number,
  URL: PropTypes.string,
  Credits: PropTypes.string,
  IsPrimary: PropTypes.boolean,
  IsPreview: PropTypes.boolean,
  IsGallery: PropTypes.boolean
});

export const ImageDefaults = {
  EntityMediaID: "",
  MediaType: "",
  EntityID: "",
  EntityType: "",
  Title: "",
  Subtitle: "",
  Description: "",
  EmbedCode: "",
  Height: 0,
  Width: 0,
  URL: "",
  Credits: "",
  IsPrimary: false,
  IsPreview: false,
  IsGallery: false
};
